import React, { useState } from 'react';
import styles from './new-password.module.scss';
import Link from 'next/link';
import Image from 'next/image';

import { Formik, ErrorMessage } from 'formik';
import { toast } from 'react-toastify';
import Heading, { SmallText, Subheading } from '../../../elements/text';
import Card from '../../../elements/card';
import Input from '../../../elements/inputs';
import Button from '../../../elements/button';
import {
  resetPassword,
  newPassword,
} from '../../../../api-client/reset-password';
import { leftArrow } from '../../../../assets/icons';
import { newPasswordValidationSchema } from '../../../../utils';
import { useRouter } from 'next/router';
import { eyeOff, eye as eyeIcon } from '../../../../public/assets/icons';

const NewPasswordWidget = () => {
  const [loading, setLoading] = useState(false);
  const router = useRouter();
  const { userId, resetToken } = router.query;
  const [eye, setEye] = useState(false);
  const [ceye, setCeye] = useState(false);

  return (
    <>
      <div className={[styles.arrow, 'container 8'].join(' ')}>
        <Image src={leftArrow} alt="left arrow " />
      </div>
      <section className="">
        <div className="">
          <Card className="">
            <header>
              <Heading className={styles.heading}>
              <p className="mb-3 text-left  font-[600] text-[#061938] lg:text-[40px] text-[25px] leading-[43px]">

Create New Password
</p>
              
                
                </Heading>
              <Subheading className="mb-6 text-left ">
            <p className='text-left py-2 my-0 lg:text-[20px] text-[14px]'>

                {
                  'Your new password must be different from previously used passwords'
                }
                </p>
              </Subheading>
            </header>
            <Formik
              // Initialise Initial Form Values
              initialValues={{ password: '', cpassword: '' }}
              // Function for Error message Display
              validationSchema={newPasswordValidationSchema}
              // Submit Function
              onSubmit={async data => {
                setLoading(true);
                const formData = {
                  password: data.password,
                  userId,
                  resetToken,
                };

                try {
                  const res = await newPassword(formData);
                  toast.success(res.data.message);
                  setLoading(false);
                  router.push('/auth/sign-in');
                } catch (error) {
                  toast.error(error.response.data.message);
                  setLoading(false);
                }
              }}
            >
              {({ values, handleChange, handleSubmit, errors, touched }) => (
                <form
                  onSubmit={e => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                <p className='text-[#061938] leading-[20px] text-[14px]lg:text-[20px]  lg:my-3 my-2  '>New Password</p>
                  <Input
                    type={eye ? 'text' : 'password'}
                    icon={<Image src={eye ? eyeIcon : eyeOff} alt="Stakecut" />}
                    onPasswordToggle={() => setEye(!eye)}
                   placeholder="new password"
                    name="password"
                    error={errors.password && touched.password}
                    value={values.password}
                    onChange={handleChange}
                    className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                  />
                  <ErrorMessage name="password">
                    {msg => (
                      <SmallText>
                        <p className="error-text mb-4">{msg}</p>
                      </SmallText>
                    )}
                    å
                  </ErrorMessage>
                  <p className='text-[#061938] leading-[20px] text-[14px]lg:text-[20px]  lg:mt-7 mt-5   '>Confirm  Password</p>
                  <Input
                    type={ceye ? 'text' : 'password'}
                    placeholder="Confirm Password"
                    onChange={handleChange}
                    icon={
                      <Image src={ceye ? eyeIcon : eyeOff} alt="Stakecut" />
                    }
                    onPasswordToggle={() => setCeye(!ceye)}
                    error={errors.cpassword && touched.cpassword}
                    value={values.cpassword}
                    name="cpassword"
                    className="border-[1px] rounded-[8px] border-[#B3BAC5]"
                  />
                  <ErrorMessage name="cpassword">
                    {msg => (
                      <SmallText>
                        <p className="error-text mb-4">{msg}</p>
                      </SmallText>
                    )}
                  </ErrorMessage>
                  <div className="mt-6">
                    <Button
                      className="btn-primary py-9 text-[14px] lg:text-[23px] px-4 w-full"
                      label="Reset Password"
                      type="submit"
                      loading={loading}
                    />
                  </div>
                </form>
              )}
            </Formik>
          </Card>
        </div>
      </section>
    </>
  );
};
export default NewPasswordWidget;
